import { ComponentTestIds } from '~/constants/test-ids';

import { Spinner } from '@vestigas/ui/molecules';

export const LoadingState = ({ title = 'Lade Daten' }) => (
  <div
    className="flex h-full flex-col items-center justify-center"
    data-testid={ComponentTestIds.TABLE.LOADING}
  >
    <Spinner
      className="h-auto w-auto rounded-full bg-white/80 p-4 px-4 py-3 shadow-sm backdrop-blur-md"
      initialDelay={600}
      title={title}
    />
  </div>
);
